import { Component, Inject, OnInit, OnDestroy, Output, EventEmitter, NgZone } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
// import { AuthService } from 'ng4-social-login';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { AppComponent } from '../../app.component';
import { AccountService } from './../../services/account.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
})
export class HeaderBarComponent implements OnInit, OnDestroy {
  isCustomer: boolean;
  currentUser: any;
  nowTime = new Date();
  @Output()
  toggleMenu = new EventEmitter();
  @Output()
  mobileMenuToggle = new EventEmitter<boolean>();
  enabled = true;
  isCollapsedMenu;
  dropDown: boolean;
  darkMode: boolean = false;
  greeting: string = '';
  isMobile: boolean = false;
  isMobileMenuOpen: boolean = false;
  private menuObserver?: MutationObserver;

  getGreeting(): string {
    const hour = new Date().getHours();
    if (hour < 12) {
      return this.translate.currentLang === 'en' ? 'Good Morning' : 'সুপ্রভাত';
    } else if (hour < 18) {
      return this.translate.currentLang === 'en' ? 'Good Afternoon' : 'শুভ অপরাহ্ন';
    } else {
      return this.translate.currentLang === 'en' ? 'Good Evening' : 'শুভ সন্ধ্যা';
    }
  }

  getUserFullName(): string {
    if (!this.currentUser) return '';
    const firstName = this.currentUser.firstName ? this.currentUser.firstName : '';
    const lastName = this.currentUser.lastName ? this.currentUser.lastName : '';
    return `${firstName} ${lastName}`.trim();
  }

  toggleDarkMode(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.darkMode = !this.darkMode;
    if (this.darkMode) {
      this.document.body.classList.add('dark-theme');
    } else {
      this.document.body.classList.remove('dark-theme');
    }
  }
  constructor(
    private accountService: AccountService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private rootComp: AppComponent,
    private socialAuthService: SocialAuthService,
    public translate: TranslateService,
    private zone: NgZone
  ) {
    this.accountService.emitChange.subscribe((status) => {
      this.toggleMenu.emit(status);
      this.isCollapsedMenu = status;
    });
  }

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();
    this.greeting = this.getGreeting();

    // Check if dark theme is already applied
    this.darkMode = this.document.body.classList.contains('dark-theme');

    // Check if mobile screen
    this.checkMobile();
    window.addEventListener('resize', () => this.checkMobile());

    // The side menu and backdrop can also close the drawer, so follow the body class
    // rather than our own flag (otherwise the button needs two taps to reopen it)
    this.isMobileMenuOpen = this.document.body.classList.contains('mobile-menu-open');
    this.menuObserver = new MutationObserver(() => {
      const open = this.document.body.classList.contains('mobile-menu-open');
      if (open !== this.isMobileMenuOpen) {
        this.zone.run(() => (this.isMobileMenuOpen = open));
      }
    });
    this.menuObserver.observe(this.document.body, { attributes: true, attributeFilter: ['class'] });

    // Subscribe to language changes to update greeting
    this.translate.onLangChange.subscribe(() => {
      this.greeting = this.getGreeting();
    });
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 767.98;
    if (!this.isMobile) {
      this.isMobileMenuOpen = false;
      this.document.body.classList.remove('mobile-menu-open');
    }
  }

  ngOnDestroy() {
    this.menuObserver?.disconnect();
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.document.body.classList.contains('mobile-menu-open');
    if (this.isMobileMenuOpen) {
      this.document.body.classList.add('mobile-menu-open');
      // Prevent body scroll when menu is open
      this.document.body.style.overflow = 'hidden';
    } else {
      this.document.body.classList.remove('mobile-menu-open');
      // Restore body scroll
      this.document.body.style.overflow = '';
    }
    this.mobileMenuToggle.emit(this.isMobileMenuOpen);
  }

  navigateToProfile() {
    this.router.navigate(['/dashboard/profile']);
  }

  onClickedOutside(e: Event) {
    if (!this.enabled) {
      this.enabled = !this.enabled;
    }

    // this.countOutside++;
  }

  navigate(user) {
    if (this.currentUser.roles.some((role) => role === 'ROLE_CUSTOMER')) {
      this.router.navigate(['/profile']);
    } else {
      this.router.navigate([`/dashboard`], { queryParams: { uid: `${this.currentUser.id}` } });
    }
  }
  sidebarToggle(status) {
    this.document.body.classList.toggle('sidebar-collapse-in');
    this.toggleMenu.emit(status);
    this.accountService.emit(status);
  }

  resetDashboard(e) {
    if (this.router.url.indexOf('/dashboard') >= 0) {
      this.accountService.resetDashboard({ accountType: 'ALL', partyId: 0 });
    } else {
      this.router.navigate([`/dashboard`], { queryParams: { uid: `${this.currentUser.id}` } });
    }
  }
}
